module.exports = new __parcel__URL__("abbey-road.8fe8147a.jpg").toString();